import { Box, Button, Stack, Typography } from "@mui/material";

const BusinessCard = () => {
  const pdfUrl = "/pdfs/Saumy_Business card.pdf";

   return (
    <Stack
      alignItems="center"
      spacing={{ xs: 2, md: 4 }}
      sx={{ py: { xs: 3, md: 6 }, px: { xs: 1, md: 0 } }}
    >
      {/* Title */}
      <Typography
        fontWeight="bold"
        sx={{
          fontSize: { xs: "18px", sm: "22px", md: "28px" },
          textAlign: "center",
        }}
      >
        Saumyadeep Datta – Business Card
      </Typography>

      {/* PDF Preview */}
      <Box
        sx={{
          width: { xs: "100%", sm: "90%", md: "80%" },
          height: { xs: "70vh", sm: "75vh", md: "80vh" },
          border: "1px solid #ccc",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <iframe
          src={pdfUrl}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="Business Card"
        />
      </Box>

      {/* Download Button */}
      <Button
        variant="contained"
        href={pdfUrl}
        download
        sx={{
          width: { xs: "90%", sm: "auto" },
          paddingX: 4,
          paddingY: 1.2,
          fontSize: { xs: "14px", sm: "16px" },
          borderRadius: "30px",
        }}
      >
        Download Business Card (PDF)
      </Button>
    </Stack>
  );
};

export default BusinessCard;